import BaseStore from './BaseStore'

export class CommentStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'comments'
  }
}

export default new CommentStore()


// WEBPACK FOOTER //
// ./src/stores/CommentStore.js